<!-- 大数据表格 -->
<template>
<basic-container>
  <div class="width-p100 bb-sm-primary mb-xxs pb-xs ds-fx flex-direction-row justify-content-start align-items-center">
    <i class="el-icon-document color-primary mr-sm"></i>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item class="link"><el-button type="text" @click="toParent">{{colObj.parentName}}</el-button></el-breadcrumb-item>
      <el-breadcrumb-item>{{colObj.name}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{sname}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
  <data-table ref="child"
    v-bind="$attrs"
    :colObj='colObj'>
    <template slot="TOP_BUTTON">
      <slot name="TOP_BUTTON"></slot>
    </template>
    <template v-for="item in [...(colObj.rowSlot || []),...(colObj.formSlot || [])]" v-slot:[item]="{row,form}">
       <slot :name="item" :row="row" :form="form"></slot>
    </template>
    <template slot="importTemp">
      <slot name="importTemp"></slot>
    </template>
  </data-table>
</basic-container>
</template>

<script>
import DataTable from '@/components/table/template/dataTable';
export default {
components: {
  DataTable,
},
props:{colObj:Object},
data() {
  return {
    sname:"", // 子名称
  };
},
computed: {},
watch: {},
//方法集合
methods: {
  toParent(){
    this.$router.push({
      path:this.colObj.parentPath,
      query:{
        runId:this.$route.query.runId,
        ...this.colObj.parentQuery
      }
    })
  }
},
created() {},
mounted() {
  this.sname=this.$route.query.sname||this.sname;
},
activated() {
  this.sname=this.$route.query.sname||this.sname;
},
}
</script>
<style lang='scss' scoped>
.link{
  /deep/ .el-breadcrumb__inner{
    color: #2E5AE8;
    cursor: pointer;
  }
  /deep/ .el-button{
    padding: 0;
  }
}
</style>